import HomeView from "./views/home";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import OrderView from "./views/order";
import LoginView from "./views/login";
import {AuthProvider} from "./contexts/auth";
import NewOrderView from "./views/newOrder";
import LogoutView from "./views/logout";
import ProtectedRoute from "./components/ProtectedRoute";
import {useContext, useEffect} from "react";
import axios from "./axios/axios";
import {Endpoints} from "./axios/endpoints";
import {ToastContainer} from 'react-toastify';
import {Redirect} from "react-router";
import AboutView from "./views/about";
import MenuView from "./views/menu";
import UsersView from "./views/users";
import {FeatureContext} from "./contexts/feature";
import {registerServiceWorker} from "./webpush/webpush";

function App() {

    let feature = useContext(FeatureContext);
    if (feature.serviceWorker) {
        registerServiceWorker();
    }

    useEffect(() => {
        axios({
            method: "get",
            url: Endpoints.XSRF
        })
    }, [])

    return (
        <AuthProvider>
            <Router>
                <Switch>
                    <Route path="/login">
                        <LoginView/>
                    </Route>
                    <Route path="/logout">
                        <LogoutView/>
                    </Route>
                    <Route path="/about">
                        <AboutView/>
                    </Route>
                    <Route path="/menu/:id">
                        <MenuView/>
                    </Route>
                    <ProtectedRoute path="/orders/:id">
                        <OrderView/>
                    </ProtectedRoute>
                    <ProtectedRoute path="/admin/users">
                        <UsersView/>
                    </ProtectedRoute>
                    <ProtectedRoute path="/new">
                        <NewOrderView/>
                    </ProtectedRoute>
                    <Route exact path="/">
                        <HomeView/>
                    </Route>
                    <Route>
                        <Redirect to={"/"}/>
                    </Route>
                </Switch>
            </Router>
            <ToastContainer pauseOnFocusLoss={false} pauseOnHover position="bottom-left"/>
        </AuthProvider>
    );
}

export default App;
